var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDarkPrintIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.222,
    height: 20,
    viewBox: "0 0 22.222 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#582bb8;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M21.889,10.056H6.333A3.329,3.329,0,0,0,3,13.389v6.667H7.444V24.5H20.778V20.056h4.444V13.389A3.329,3.329,0,0,0,21.889,10.056ZM18.556,22.278H9.667V16.722h8.889ZM21.889,14.5A1.111,1.111,0,1,1,23,13.389,1.114,1.114,0,0,1,21.889,14.5Zm-1.111-10H7.444V8.944H20.778Z",
    transform: "translate(-3 -4.5)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkPrintIcon);
export default __webpack_public_path__ + "static/media/dark-print-icon.06cca328e1a60786b674c4d87936784d.svg";
export { ForwardRef as ReactComponent };